/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum InventoryCountType {
  Full = 'FULL',
  Category = 'CATEGORY'
}
